import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function EFootPage() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-321">
      <Header data-id="element-322" />

      <main className="flex-grow pt-32 pb-20" data-id="element-323">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-324">
          {/* Title */}
          <h1 className="text-3xl font-bold text-red-600 mb-2" data-id="element-325">E-FOOTGEAR</h1>

          <div className="text-right text-xs text-gray-500 mb-2" data-id="element-326">
            Information provided by the manufacture, Truescore
          </div>

          {/* Main Image */}
          <div className="mb-8 overflow-hidden rounded-lg shadow-sm border border-gray-200" data-id="element-327">
            <img src="https://cdn.magicpatterns.com/uploads/igVgSuirxUeXPNbvsJ8XLX/e-Footgear_versions.jpg" alt="Daedo E-Footgear variations" className="w-full h-auto object-cover" data-id="element-328" />
          </div>

          {/* Versions Table */}
          <div className="mb-4" data-id="element-329">
            <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-330">
              E-FOOTGEAR VERSIONS
            </h2>
            <div className="overflow-x-auto" data-id="element-331">
              <table className="w-full border-collapse text-sm text-left" data-id="element-332">
                <thead data-id="element-333">
                  <tr className="bg-blue-800 text-white" data-id="element-334">
                    <th className="p-3 border border-gray-300 w-1/5 bg-white text-gray-900" data-id="element-335"></th>
                    <th className="p-3 border border-gray-300 font-bold" data-id="element-336">
                      E-FOOT G4 (Grey)
                    </th>
                    <th className="p-3 border border-gray-300 font-bold" data-id="element-337">
                      E-HEEL
                    </th>
                    <th className="p-3 border border-gray-300 font-bold" data-id="element-338">
                      E-FOOT COMPLETE
                    </th>
                    <th className="p-3 border border-gray-300 font-bold" data-id="element-339">
                      GEN2 E-FOOT
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-340">
                  <tr data-id="element-341">
                    <td className="p-3 border border-gray-300 font-bold bg-gray-50" data-id="element-342">
                      # of Sensors
                    </td>
                    <td className="p-3 border border-gray-300" data-id="element-343">6</td>
                    <td className="p-3 border border-gray-300" data-id="element-344">1</td>
                    <td className="p-3 border border-gray-300" data-id="element-345">7</td>
                    <td className="p-3 border border-gray-300" data-id="element-346">11</td>
                  </tr>
                  <tr className="bg-gray-200" data-id="element-347">
                    <td className="p-3 border border-gray-300 font-bold" data-id="element-348">
                      Recommended PSS
                    </td>
                    <td className="p-3 border border-gray-300" data-id="element-349">GEN 1 HOGU</td>
                    <td className="p-3 border border-gray-300" data-id="element-350">
                      GEN 1 HOGU + HEAD
                    </td>
                    <td className="p-3 border border-gray-300" data-id="element-351">
                      GEN 1 HOGU + HEAD
                    </td>
                    <td className="p-3 border border-gray-300" data-id="element-352">GEN 2 HOGU</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="text-right text-sm text-gray-600 mt-2" data-id="element-353">
              Updated March 2017
            </div>
          </div>

          {/* Usage Recommendations Text */}
          <div className="mt-10 space-y-6 text-gray-800 leading-relaxed" data-id="element-354">
            <h2 className="text-lg font-bold text-gray-900 uppercase" data-id="element-355">
              E-FOOTGEAR VERSION HISTORY AND USAGE RECOMMENDATIONS
            </h2>

            <p data-id="element-356">
              With the different versions of E-Footgear out there, it is easy to
              become confused about which version to use. The chart above shows
              the recommended PSS minimum qualifications for use of that
              particular type of E-Footgear. Most athletes are familiar with the
              Gen1 V4 E-Footgear because the Gen1 PSS (E-Hogu) is the most
              common PSS used at local, state, and national levels (USA in
              particular).
            </p>

            <p data-id="element-357">
              Some events also implement E-Headgear for higher ranking divisions
              and that is where the E-Heel is often seen. For a short amount of
              time, the E-Foot Complete was popular among those divisions
              because of the convenience of a single piece E-Footgear for E-Head
              events. Yet, there are advantages to having a detachable E-Heel
              like more versatile use/acceptance based on the regulations of
              various tournaments so the E-Foot Complete is rarely seen or
              purchased.
            </p>

            <p data-id="element-358">
              In 2016, the Gen2 PSS was introduced at the Rio Olympics and with
              it, a new E-Footgear. Officially, the Gen2 E-Footgear is only to
              be used with the Gen2 PSS as the manufacturers/inventors intended.
              Yes, technically the Gen2 E-Footgear does work on a Gen1
              E-Chestgear. However, the added sensors in the Gen2 E-Footgear
              make producing a scoring hit significantly easier. Thus, a fighter
              wearing Gen2 E-Footgear, competing with Gen1 PSS, will have an
              advantage over a fighter wearing Gen1 E-Footgear V4. To create a
              fair match and event, tournament directors and organizers are
              highly recommended to restrict the Gen2 E-Footgear usage to Gen2
              PSS only. This is also in consideration of the vast majority of
              athletes so that they are not pressured to purchase a more
              expensive E-Footgear unnecessarily.
            </p>

            <p data-id="element-359">
              To put things in perspective, the Gen2 PSS was developed for
              higher level elite competition. It is generally more difficult to
              score as it requires higher levels of impact and technique. The
              appropriate divisions for Gen2 PSS are Black Belt Cadet, Junior,
              Senior Elite/World Class. The Gen1 PSS is thus recommended for all
              other divisions.
            </p>
          </div>
        </div>
      </main>

      <Footer data-id="element-360" />
    </div>;
}